import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getTrailsPage } from "@/_pages/trails/api";
import type { TrailsListType, TrailsPageType } from "@/_pages/trails/model";
import { TrailsPage } from "@/_pages/trails/ui";

type PageProps = {
  cms: {
    pageData: TrailsPageType;
    trails: TrailsListType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { pageData, trails },
  } = props;

  return <TrailsPage pageData={pageData} trails={trails} />;
};

export const getServerSideProps: GetServerSideProps<PageProps> = async ({
  res,
}) => {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getTrailsPage()),
      };
    },
    { res },
  );
};

export default Page;
